import { useCallback } from "react";

import type { AppLocale } from "@/i18n/config";
import { useAppLocale, useSwitchLocale } from "@/i18n/context";
import { useAuth } from "@/lib/auth/auth-context";
import { updateProfile } from "@/services/profile";

export const useLocaleSwitch = () => {
  const locale = useAppLocale();
  const switchLocale = useSwitchLocale();
  const { isAuthenticated } = useAuth();

  const switchAppLocale = useCallback(
    (target: AppLocale) => {
      if (target === locale) return;
      switchLocale(target);
      if (isAuthenticated) {
        updateProfile({ language: target }).catch(() => {});
      }
    },
    [locale, switchLocale, isAuthenticated],
  );

  return { locale, switchAppLocale };
};
